import React from 'react';

interface Props {
  percent: number; // 0~100+
  className?: string;
}

function colorByPercent(p: number): string {
  if (p >= 100) return 'bg-emerald-500';
  if (p >= 50) return 'bg-green-500';
  if (p > 0) return 'bg-rose-500';
  return 'bg-slate-300';
}

export const ProgressBar: React.FC<Props> = ({ percent, className = '' }) => {
  const safe = Math.max(0, Math.min(percent, 100));
  const color = colorByPercent(percent);
  return (
    <div className={`w-full h-2.5 rounded-full bg-slate-100 overflow-hidden ${className}`} role="progressbar" aria-valuenow={safe} aria-valuemin={0} aria-valuemax={100}>
      <div className={`h-2.5 ${color}`} style={{ width: `${safe}%` }} />
    </div>
  );
};

export default ProgressBar;


